"use strict";
import AbstractPage from 'page/AbstractPage';
import ProductFilter from 'component/ProductFilter';
import ProductListViewMode from 'component/ProductListViewMode';
import tools from 'tools';

export default class ProductListPage extends AbstractPage {
    constructor() {
        super();

        this.rebuildSectionsList();
        this.viewMode = new ProductListViewMode;
        this.initFilter();
    }

    initFilter() {
        this.filter = new ProductFilter;
        const mql = window.matchMedia('(min-width: 768px)');

        const resizeCallback = (e) => {
            if ( window.matchMedia('(min-width: 768px)').matches ) {
                $('.product-filter').css('display', 'block');
            } else {
                $('.product-filter').css('display', 'none');
            }
        };

        try {
            mql.addEventListener('change', resizeCallback);
        } catch (ex) {
            try {
                mql.addListener(resizeCallback);
            } catch (ex) {}
        }

        if (mql.matches) {
            $('.product-filter').css('display', 'block');
        } else {
            $('.product-filter').css('display', 'none');
        }

        $('.catalog-filter-mobile-trigger').on('click', function () {
            $('.product-filter').slideToggle();
        });
    }

    rebuildSectionsList() {
        $('.product-section-list-extended-item .product-section-list-title').each((index, el) => {
            const html = `
                <span class="product-section-list-title__extra">
                    <span class="product-section-list-title__extra-text"><span>открыть</span><br>${$(el).attr('data-count')} ${tools.plural($(el).attr('data-count'), 'товар', 'товара', 'товаров')}</span>
                    <svg class="product-section-list-title__extra-icon"><use xlink:href="#angle-bottom"></use></svg>
                </span>
            `;
            $(el).append(html);
        });
    }
}

$(function () { app.pageController = new ProductListPage(); });
